{
  "401": {
    "title": "You are not authorized to access this page.",
    "text": "If you think this is not right, contact the administrator",
    "back_button": "Back to dashboard"
  },
  "403": {
    "title": "You do not have permission to access this page.",
    "text": "If you think this is a mistake, please contact the administrator.",
    "back_button": "Back to dashboard"
  },
  "404": {
    "title": "This page was not found.",
    "text": "The requested page could not be found.",
    "back_button": "Back to dashboard"
  },
  "general": {
    "dateFormat": "MM/dd/yyyy",
    "fullDateFormat": "MM/dd/yyyy HH:mm:ss",
    "logout": "Logout",
    "account": "Account",
    "profile": "Profile",
    "hello": "Hello",
    "home": "Home",
    "loading": "Loading...",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "close": "Close",
    "view": "View",
    "save": "Save",
    "records": "Records",
    "add": "Add",
    "read": "Read",
    "write": "Save",
    "edit": "Edit",
    "new": "New",
    "delete": "Delete",
    "actions": "Actions",
    "active": "Active",
    "inactive": "Inactive",
    "search": "Search",
    "select": "Select",
    "none": "None",
    "yes": "Yes",
    "no": "No",
    "years": "Years",
    "months": "Months",
    "favorites": "Favorites",
    "reports": "Reports",
    "recordsPerPage": "Records per page",
    "changePassword": "Change password",
    "longDateFormat": "{years} year(s) and {months} month(s)",
    "importData": "Import data",
    "upload": "Upload",
    "downloadTemplate": "Download template",
    "selectOption": "Select an option",
    "id": "ID",
    "translations": "Translations",
    "or": "or",
    "review": "Review",
    "approve": "Approve",
    "reject": "Reject",
    "reviewComments": "Review Comments",
    "reviewOnBehalfOf": "Review on behalf of",
    "reviewed": "Reviewed",
    "reviewedBy": "Reviewed By ",
    "pending": "Pending",
    "approved": "Approved",
    "rejected": "Rejected",
    "skipped": "Skipped",
    "warning": "Warning",
    "manager": "Manager",
    "move": "Move",
    "leave": "Leave",
    "export": "Export",
    "import": "Import",
    "next": "Next",
    "previous": "Previous",
    "done": "Done",
    "run": "Run",
    "form": "Form",
    "status": "Status",
    "emailTemplate": "Email Template",
    "send": "Send",
    "saving": "Saving...",
    "saved": "Saved",
    "loadData": "Load Data",
    "download": "Download",
    "noData": "No data available in table",
    "cropImage": "Crop Image",
    "selectImageToCrop": "Select an image to crop",
    "selectImage": "Select Image",
    "list": "List",
    "group": "Group",
    "attach": "Attach",
    "exportCsv": "Export CSV",
    "auditFields": "Audit Fields",
    "saveDisplayOrder": "Save Display Order",
    "permissionActions": {
      "read": "Read",
      "write": "Write",
      "delete": "Delete",
      "execute": "Execute"
    },
    "messages": {
      "personNotFound": "Person not found. Contact Admin.",
      "notRegisteredSessionOnly": "You are not registered in JTP, so this change will only apply to your current session. Please contact the administrator to be added.",
      "formUnsavedChanges": "You have unsaved changes. Are you sure you want to close?",
      "serverError": "Server error. Please try again later or contact the system administrator.",
      "networkError": "Could not connect to the server. Check your internet connection or contact the system administrator.",
      "forbidden": "You do not have permission to access this resource. Contact the system administrator if you think this is a mistake.",
      "fileUploadError": "Error uploading the file. Check the file format and size and try again.",
      "fileUploadSuccessEmail": "File uploaded successfully. An email with the import result will be sent soon.",
      "failedLoadPermissions": "Failed to load user permissions. Please refresh the page or contact the system administrator.",
      "downloadingFile": "Downloading file...",
      "fileDownloadError": "Error downloading the file. Please try again or contact the system administrator.",
      "fileImportedSuccessfully": "File imported successfully.",
      "invalidFileFormat": "Invalid file format. Please check the file and try again.",
      "exportFailed": "Failed to export data. Please try again or contact the system administrator."
    },
    "warnings": {
      "maxDisplayedRecords": "Displaying {shown} records out of {filtered}. To view additional records, use the search function."
    },
    "info": {
      "dragAndDropInfo": "Drag-and-drop any person to organize the tree"
    },
    "validation": {
      "required": "This field is required.",
      "email": "Please enter a valid email address.",
      "minValue": "The value must be at least {min}.",
      "maxValue": "The value cannot be greater than {max}.",
      "minLength": "The value must be at least {min} characters.",
      "maxLength": "The value cannot exceed {max} characters.",
      "onlyIntegers": "The value must be an integer.",
      "invalidDate": "The entered date is invalid.",
      "dateAfterOrEqual": "Date must be after or equal {date}"
    },
    "baseAuditableEntity": {
      "createdBy": "Created By",
      "createdDate": "Created Date",
      "modifiedBy": "Modified By",
      "modifiedDate": "Modified Date"
    }
  },
  "enums": {
    "potentialSuccessorType": {
      "1": "Internal",
      "2": "External"
    },
    "readinessFactor": {
      "0": "N/A",
      "1": "Ready Now",
      "2": "Ready with Development (1-2 Years)",
      "3": "Ready with Development (2-3 Years)",
      "4": "Emergency Backfill"
    },
    "positionType": {
      "1": "Buy",
      "2": "Make",
      "3": "Sell",
      "4": "Support"
    },
    "personStatus": {
      "1": "Active",
      "2": "Inactive",
      "3": "Termed"
    },
    "communicationPriority": {
      "1": "Normal",
      "2": "High"
    },
    "personTypes": {
      "0": "Unknown",
      "1": "Salaried Employee",
      "2": "Contractor",
      "3": "Vendor",
      "4": "Hourly Employee",
      "5": "External",
      "6": "DU Hourly Inactive",
      "7": "DU Salaried Inactive",
      "8": "DU Truck Driver In",
      "9": "Executive",
      "10": "Union",
      "11": "Non Union",
      "12": "Union Possible",
      "13": "Salaried Non Exempt",
      "14": "Hourly",
      "15": "DU Paid Leave",
      "17": "Truck Driver",
      "18": "DU Unpaid Leave",
      "19": "Work Release",
      "20": "External Access Level One",
      "21": "External Access Level Two",
      "22": "External Access Level Three",
      "23": "External Access Level Four",
      "24": "External Access Level Five",
      "99": "Global Employee"
    },
    "customerSpecificStatus": {
      "0": "Unknown",
      "1": "Active",
      "2": "Inactive",
      "3": "Income Assistance",
      "4": "Leave of Absence",
      "5": "Retiree",
      "6": "Withdrawn"
    },
    "resourceType": {
      "1": "Application",
      "2": "Module",
      "3": "Page",
      "4": "Page Section",
      "5": "Page Action",
      "6": "Page Field",
      "7": "Data"
    },
    "securityResourceAction": {
      "0": "None",
      "1": "Read",
      "2": "Write",
      "3": "Read and Write",
      "4": "Execute",
      "5": "Read and Execute",
      "6": "Write and Execute",
      "7": "Read, Write and Execute",
      "8": "Delete",
      "9": "Read and Delete",
      "10": "Write and Delete",
      "11": "Read, Write and Delete",
      "12": "Execute and Delete",
      "13": "Read, Execute and Delete",
      "14": "Write, Execute and Delete",
      "15": "All"
    }
  },
  "report": {
    "viewer": {
      "grid": {
        "pivotMode": "Pivot Mode",
        "groups": "Row Groups",
        "rowGroupColumnsEmptyMessage": "Drag here to set row groups",
        "values": "Values",
        "valueColumnsEmptyMessage": "Drag here to aggregate",
        "pivots": "Column Labels",
        "pivotColumnsEmptyMessage": "Drag here to set column labels",
        "columns": "Columns",
        "filters": "Filters",
        "loadingOoo": "Loading...",
        "noRowsToShow": "No Rows To Show",
        "enabled": "Enabled",
        "group": "Group",
        "footerTotal": "Total",
        "filterOoo": "Filter...",
        "searchOoo": "Search...",
        "blanks": "(Blanks)",
        "selectAll": "(Select All)",
        "selectAllSearchResults": "(Select All Search Results)",
        "noMatches": "No matches",
        "equals": "Equals",
        "notEqual": "Does not equal",
        "blank": "Blank",
        "notBlank": "Not blank",
        "lessThan": "Less than",
        "greaterThan": "Greater than",
        "lessThanOrEqual": "Less than or equal to",
        "greaterThanOrEqual": "Greater than or equal to",
        "inRange": "Between",
        "inRangeStart": "From",
        "inRangeEnd": "To",
        "contains": "Contains",
        "notContains": "Does not contain",
        "startsWith": "Begins with",
        "endsWith": "Ends with",
        "before": "Before",
        "after": "After",
        "andCondition": "AND",
        "orCondition": "OR",
        "applyFilter": "Apply",
        "resetFilter": "Reset",
        "clearFilter": "Clear",
        "cancelFilter": "Cancel",
        "textFilter": "Text Filter",
        "numberFilter": "Number Filter",
        "dateFilter": "Date Filter",
        "setFilter": "Set Filter",
        "pinColumn": "Pin Column",
        "pinLeft": "Pin Left",
        "pinRight": "Pin Right",
        "noPin": "No Pin",
        "valueAggregation": "Value Aggregation",
        "noAggregation": "None",
        "autosizeThisColumn": "Autosize This Column",
        "autosizeAllColumns": "Autosize All Columns",
        "groupBy": "Group by",
        "ungroupBy": "Un-Group by",
        "ungroupAll": "Un-Group All",
        "addToValues": "Add {'${variable}'} to values",
        "removeFromValues": "Remove {'${variable}'} from values",
        "addToLabels": "Add {'${variable}'} to labels",
        "removeFromLabels": "Remove {'${variable}'} from labels",
        "resetColumns": "Reset Columns",
        "expandAll": "Expand All Row Groups",
        "collapseAll": "Collapse All Row Groups",
        "copy": "Copy",
        "copyWithHeaders": "Copy With Headers",
        "copyWithGroupHeaders": "Copy with Group Headers",
        "cut": "Cut",
        "paste": "Paste",
        "export": "Export",
        "csvExport": "CSV Export",
        "excelExport": "Excel Export",
        "sum": "Sum",
        "first": "First",
        "last": "Last",
        "min": "Min",
        "max": "Max",
        "count": "Count",
        "avg": "Average",
        "average": "Average",
        "filteredRows": "Filtered",
        "selectedRows": "Selected",
        "totalRows": "Total Rows",
        "totalAndFilteredRows": "Rows"
      },
      "noFilterMessage": "No filters for this report",
      "noAccessReport": "You do not have access to view this report. Please contact the system administrator if you think this is a mistake.",
      "pdfSizeErrorMessage": "The PDF size is too big and can not be showed.",
      "pdfMaxSizeDownloaded": "The report is too large to display. Check your download folder.",
      "failedLoadReports": "Failed to load reports. Other features will work as expected. Please refresh the page or contact the system administrator if the problem persists.",
      "run": "Run",
      "download": "Download",
      "viewFilter": {
        "button": "View Filters...",
        "title": "Parameters",
        "name": "Name",
        "value": "Value"
      },
      "fullScreen": "Full Screen...",
      "smallScreen": "Small Screen...",
      "tabButton": {
        "fullScreen": "Hide parameters section",
        "smallScreen": "Show parameters section",
        "about": "About",
        "downloadExcel": "Download SpreadSheet file",
        "clear": "Close All Tabs"
      },
      "modalAbout": {
        "title": "About",
        "description": "Description",
        "version": "Version",
        "reference": "Reference",
        "lastChange": "Lastest Change",
        "dataSource": "Data Source"
      }
    },
    "maintenance": {
      "menuName": "Reports",
      "pageTitle": "Reports",
      "id": "ID",
      "title": "Title",
      "reference": "Reference",
      "directoryTree": "Directory Tree",
      "directoryTreeHelp": "Use backslash to separate folders, e.g. Reports\\Finance\\Monthly",
      "reportType": "Report Type",
      "typeGrid": "Grid",
      "typeForm": "Form",
      "securityResource": "Security Resource",
      "description": "Description",
      "versionNumber": "Version",
      "isActive": "Active",
      "isSchedulable": "Schedulable",
      "isArchivable": "Archivable",
      "isAuditable": "Auditable",
      "passMultiValue": "Pass Multi-Value as String",
      "expireInDays": "Expire in Days",
      "add": "Add Report",
      "edit": "Edit Report",
      "delete": {
        "title": "Delete Report",
        "text": "Are you sure you want to delete \"{name}\"?"
      },
      "messages": {
        "created": "Report created successfully.",
        "updated": "Report saved successfully.",
        "deleted": "Report deleted successfully.",
        "imported": "Report imported successfully."
      },
      "sections": {
        "main": "Main Properties",
        "parameters": "Parameters",
        "sqls": "SQL Statements",
        "grids": "Result Grids",
        "models": "Report Models"
      },
      "sql": {
        "add": "Add SQL Statement",
        "edit": "Edit SQL Statement",
        "description": "Description",
        "connection": "Connection",
        "multipleResultset": "Multiple Resultsets",
        "sql": "SQL",
        "generateGrids": "Generate Grids from SQL",
        "generateGridsSuccess": "Grid generated successfully. Review it in the Result Grids tab.",
        "delete": {
          "title": "Delete SQL Statement",
          "text": "Are you sure you want to delete \"{name}\"?"
        }
      },
      "grid": {
        "add": "Add Grid",
        "edit": "Edit Grid",
        "label": "Label",
        "resultsetNumber": "Resultset #",
        "parentGrid": "Parent Grid",
        "defaultGroupedColumns": "Default Grouped Columns",
        "relationString": "Relation String",
        "delete": {
          "title": "Delete Grid",
          "text": "Are you sure you want to delete \"{name}\"?"
        }
      },
      "column": {
        "add": "Add Column",
        "edit": "Edit Column",
        "columnName": "Column Name",
        "label": "Label",
        "header": "Header",
        "dataType": "Data Type",
        "sumarizeType": "Summarize",
        "showOrder": "Order",
        "mask": "Mask",
        "helpText": "Help Text",
        "template": "Template",
        "delete": {
          "title": "Delete Column",
          "text": "Are you sure you want to delete \"{name}\"?"
        }
      },
      "param": {
        "add": "Add Parameter",
        "edit": "Edit Parameter",
        "displayOrder": "Order",
        "name": "Name",
        "nameValidation": "Only letters, numbers and underscores are allowed.",
        "label": "Label",
        "dataType": "Data Type",
        "defaultValue": "Default Value",
        "helpText": "Help Text",
        "required": "Required",
        "multiple": "Multiple Values",
        "width": "Width (cols)",
        "enumValues": "Values (semicolon-separated)",
        "enumValuesHelp": "e.g. 1;2;3",
        "enumLabels": "Labels (semicolon-separated)",
        "enumLabelsHelp": "e.g. Option A;Option B;Option C",
        "sql": "SQL Query",
        "generate": "Generate parameters from SQL",
        "delete": {
          "title": "Delete Parameter",
          "text": "Are you sure you want to delete \"{name}\"?"
        }
      },
      "model": {
        "add": "Add Model",
        "edit": "Edit Model",
        "description": "Description",
        "order": "Order",
        "connection": "Connection",
        "file": "Model File (.trdx / .trdp)",
        "fileLoaded": "File loaded successfully.",
        "delete": {
          "title": "Delete Model",
          "text": "Are you sure you want to delete \"{name}\"?"
        }
      },
      "paramDataType": {
        "text": "Text",
        "number": "Number",
        "date": "Date",
        "time": "Time",
        "combo": "Combo",
        "boolean": "Boolean",
        "sql": "SQL"
      },
      "colDataType": {
        "text": "Text",
        "number": "Number",
        "date": "Date",
        "time": "Time",
        "combo": "Combo",
        "boolean": "Boolean"
      },
      "sumarizeType": {
        "nosumarize": "None",
        "sum": "Sum",
        "min": "Min",
        "max": "Max",
        "average": "Average",
        "count": "Count"
      },
      "import": {
        "connection": "Connection Override",
        "connectionHelp": "Optional: override all connection references in the imported file."
      }
    }
  },
  "file": {
    "description": "Description",
    "files": "Files",
    "editDescription": "Edit Description",
    "delete": "Delete File",
    "download": "Download File",
    "pendingUpload": "Pending upload. The file will only be saved after clicking 'Save'.",
    "noFiles": "No files added."
  },
  "dashboard": {
    "menuTitle": "Dashboard",
    "title": "Dashboard",
    "addWidget": "Add Widget",
    "editLayout": "Edit Layout",
    "saveLayout": "Save Layout",
    "importLayout": "Import Layout",
    "exportLayout": "Export Layout",
    "category": "Category",
    "widget": "Widget",
    "widgetTitle": "Title",
    "widgetParameters": "Parameters",
    "widgetInformation": "Widget Information",
    "noParameters": "This widget has no parameters.",
    "delete": "Delete Widget",
    "viewLink": "view",
    "noItemsToDisplay": "No items to display",
    "messages": {
      "saveSuccess": "Layout saved successfully.",
      "importSuccess": "Layout imported successfully.",
      "exportSuccess": "Layout exported successfully.",
      "importFailed": "Failed to import layout.",
      "widgetNotFound": "Widget not found",
      "failedToLoad": "Failed to load",
      "noDataAvailable": "No data available",
      "noParametersConfigured": "No parameters configured for this widget."
    },
    "tutorial": {
      "mainMessage": "Welcome to your dashboard! Use the buttons above to customize it.",
      "callToAction": "Show me how!",
      "instructions": {
        "add": {
          "title": "Add Widget Button",
          "description": "Here you'll be able to find widgets by category. Some of them can have parameters to allow you a fully customizable dashboard. Don't forget to hit SAVE after adding all your widgets."
        },
        "edit": {
          "title": "Edit Widget Layout",
          "description": "Here you'll be able to change your dashboard: Add or remove widgets, move and resize them. Don't forget to hit save after editing."
        },
        "import": {
          "title": "Import Layout",
          "description": "With a backup file, here you can import it. Note: Your dashboard will be overridden."
        },
        "export": {
          "title": "Export Layout",
          "description": "Once you have your dashboard completed, you can export it to have a backup OR send it to another user to copy your dashboard."
        }
      }
    }
  },
  "communication": {
    "title": "Communications",
    "menuTitle": "Communications",
    "menuName": "Communications",
    "markAsRead": "Mark as Read",
    "subject": "Subject",
    "date": "Date",
    "priority": "Priority",
    "backToInbox": "Back to Inbox",
    "noMessages": "No messages in your inbox.",
    "status": "Status",
    "read": "Read",
    "unread": "Unread",
    "edit": "View",
    "messages": {
      "markedAsRead": "Communication acknowledged"
    }
  },
  "settings": {
    "title": "Settings",
    "theme": {
      "name": "Theme",
      "dark": "Dark",
      "light": "Light"
    }
  },
  "userInfo": {
    "title": "User Information",
    "permissions": "Permissions",
    "userName": "Username",
    "fullName": "Full Name",
    "email": "Email",
    "employeeId": "Employee ID",
    "action": "Action",
    "permissionCode": "Permission Code"
  },
  "profile": {
    "title": "My Profile",
    "menuName": "Profile",
    "score": "Profile Score",
    "managerWarning": "Information provided in the 'My Profile' page is accessible to Managers and HR in the organization for Talent Mapping purposes.",
    "photo": "Change Picture",
    "name": "Name",
    "email": "Email",
    "manager": "Manager",
    "position": "Position",
    "plant": "Plant",
    "businessArea": "Business Area",
    "degreeType": "Degree",
    "degreeName": "Name of Degree or Certificate Here",
    "language": "Languages",
    "languagesInfo": "Select all languages you speak",
    "geoMobility": {
      "label": "Geographic Mobility",
      "none": "None",
      "local": "Local",
      "national": "National",
      "international": "International"
    },
    "businessMobility": "Business Unit Mobility",
    "skills": "My Skills",
    "skillsInfo": "Select your areas of expertise",
    "careerInterests": "Career Interests",
    "careerAspirations": "Career Aspirations",
    "jobHistory": "Relevant Job History",
    "save": "Save",
    "invalidPhotoFormat": "File format not supported. Please use PNG or JPEG.",
    "photoCrop": {
      "title": "Profile photo",
      "selectImage": "Upload",
      "confirm": "Apply",
      "cancel": "Cancel",
      "deletePhoto": "Remove",
      "hint": "Drag to reposition. Pinch or scroll to zoom.",
      "emptyState": "No image selected. Click \"Upload\" to get started."
    },
    "messages": {
      "saved": "Profile saved successfully",
      "notRegistered": "You are not registered in JTP. Please contact HR to be added. Until then, your access will be restricted."
    }
  },
  "impersonate": {
    "title": "Impersonate User",
    "userName": "Login",
    "start": "Start Impersonation",
    "messages": {
      "impersonationStarted": "Impersonation section started. To return to your account, please log out and log back in.",
      "userNotFound": "User not found. Please check the username and try again."
    }
  },
  "about": {
    "menuName": "About",
    "title": "About"
  },
  "releaseNotes": {
    "menuName": "Release Notes",
    "title": "Release Notes",
    "name": "Name",
    "version": "Version",
    "description": "Description",
    "appType": "Application Type",
    "releaseDate": "Release Date",
    "messages": {
      "notFound": "Release note not found.",
      "saveError": "Error saving release note. Please try again later."
    }
  },
  "help": {
    "menuTitle": "Help",
    "externalLinkMessage": "You are about to open an external link:",
    "externalLinkConfirm": "Open link",
    "lastUpdated": "Last updated: {date}",
    "wasThisHelpful": "Was this helpful?",
    "helpful": "Helpful",
    "notHelpful": "Not helpful",
    "pageModal": {
      "title": "Help for this page",
      "intro": "Help articles give you guidance for the page you're on. Select one to open it, or close this window."
    }
  },
  "admin": {
    "menuTitle": "Administration",
    "appCustomizations": {
      "menuName": "App Customizations",
      "pageTitle": "App Customizations",
      "imageLogos": "Image Logos",
      "headerLogo": "Header Logo",
      "menuLogo": "Menu Logo",
      "bannerImage": "Banner Image",
      "upload": "Upload",
      "remove": "Remove",
      "noCustom": "Default image",
      "preview": "Preview",
      "messages": {
        "saved": "Customizations saved successfully.",
        "invalidKey": "Invalid logo key.",
        "invalidLanguage": "Invalid language code.",
        "fileRequired": "File is required.",
        "fileTooLarge": "File exceeds the maximum allowed size of 2 MB.",
        "fileTypeNotAllowed": "File type not allowed. Use PNG, JPEG, or WebP.",
        "notFound": "Customization not found."
      }
    },
    "help": {
      "menuName": "Help",
      "pageTitle": "Help",
      "title": "Title",
      "description": "Description",
      "isActive": "Is Active",
      "isMenuDisplayed": "Show in Menu",
      "isMenuDisplayedInfo": "When off, this help is hidden from the Help menu but can still be opened from the help icon on its associated pages.",
      "isTrackingEnabled": "Enable Tracking",
      "isTrackingEnabledInfo": "When on, page views are recorded per employee and a \"was this helpful\" rating is shown on the help page.",
      "viewCount": "Views",
      "viewCountValue": "Viewed {views} times by {viewers} people",
      "viewCountInfo": "Total number of views and the number of distinct employees who opened this help.",
      "helpfulCount": "Helpful",
      "notHelpfulCount": "Not helpful",
      "displayOrder": "Display Order",
      "securityResources": "Security Resources",
      "securityResourcesInfo": "Comma-separated list of permissions. Leave empty to make this available to everyone; otherwise the user must have at least one of the listed permissions.",
      "associatedMenus": "Associated Pages",
      "associatedMenusInfo": "Attach this help to one or more pages so it can be opened directly from the help icon on those pages.",
      "addMenu": "Add page",
      "add": "Add Help",
      "edit": "Edit Help",
      "delete": {
        "title": "Delete Help",
        "text": "Are you sure you want to delete this help entry?"
      },
      "messages": {
        "created": "Help created successfully.",
        "updated": "Help updated successfully.",
        "deleted": "Help deleted successfully.",
        "notFound": "Help not found."
      }
    },
    "menuHierarchy": {
      "menuName": "Menu Hierarchy",
      "pageTitle": "Menu Hierarchy",
      "displayName": "Display Name",
      "displayNameKey": "Isso????",
      "route": "Route",
      "routeParam": "Menu Parameter",
      "securityResources": "Security Resources",
      "children": "Sub-Menus",
      "isActive": "Is Active",
      "icon": "Icon",
      "iconHelpText": "Icons library",
      "displayOrder": "Display Order",
      "edit": "Edit Menu Item",
      "messages": {
        "success": "Menu item saved successfully."
      }
    },
    "notificationTemplate": {
      "menuName": "Notification Template",
      "pageTitle": "Notification Template",
      "name": "Name",
      "parent": "Parent Template",
      "parentInfo": "Only templates starting with masterTemplate can be used as a parent template.",
      "pushNotificationEnabled": "Push Notification Enabled",
      "pushRoute": "Push Notification Route",
      "sqlQuery": "SQL Query",
      "sqlQueryDateFormatInfo": "Date columns must be formatted in mm/DD/yyyy format.",
      "generalSection": "General Information",
      "emailSection": "Email Notification",
      "emailSubject": "Email Subject",
      "emailBody": "Email Body (HTML)",
      "pushSection": "Push Notification",
      "pushSubject": "Push Subject",
      "pushBody": "Push Body",
      "overrideNotificationTemplate": "Override Existing Template",
      "add": "Add Template",
      "edit": "Edit Template",
      "delete": {
        "title": "Delete Template",
        "text": "Are you sure you want to delete the template \"{name}\"?"
      },
      "attachment": {
        "title": "Attach File",
        "attachment": "Attachment",
        "attach": "Attach",
        "noAttachedFile": "No attachment added...",
        "messages": {
          "uploadedSuccessfully": "Attachment uploaded successfully."
        },
        "delete": {
          "title": "Delete Attachment",
          "text": "Are you sure you want to delete the attachment \"{name}\"?"
        }
      },
      "messages": {
        "created": "Notification template created successfully.",
        "updated": "Notification template updated successfully.",
        "deleted": "Notification template deleted successfully.",
        "alreadyExists": "A notification template with this name already exists.",
        "fileRequired": "The file is required.",
        "importError": "An error occurred while importing the notification template.",
        "notFound": "Notification template not found."
      }
    },
    "department": {
      "menuName": "Department",
      "pageTitle": "Department",
      "externalId": "External Id",
      "name": "Name",
      "isActive": "Is Active",
      "add": "Add Department",
      "edit": "Edit Department",
      "delete": {
        "title": "Delete Department",
        "text": "Are you sure you want to delete this department?"
      },
      "messages": {
        "created": "Department created successfully.",
        "updated": "Department updated successfully.",
        "deleted": "Department deleted successfully."
      }
    },
    "businessArea": {
      "menuName": "Business Area",
      "pageTitle": "Business Area",
      "id": "Id",
      "externalId": "External Id",
      "description": "Description",
      "calendarId": "Calendar",
      "isActive": "Is Active",
      "edit": "Edit Business Area",
      "messages": {
        "created": "Business Area created successfully.",
        "updated": "Business Area updated successfully.",
        "deleted": "Business Area deleted successfully."
      }
    },
    "businessUnit": {
      "menuName": "Business Unit",
      "pageTitle": "Business Unit",
      "id": "Id",
      "externalId": "External Id",
      "description": "Description",
      "isActive": "Is Active",
      "edit": "Edit Business Unit",
      "messages": {
        "created": "Business Unit created successfully.",
        "updated": "Business Unit updated successfully.",
        "deleted": "Business Unit deleted successfully.",
        "inUse": "Business Unit record is in use. First delete its uses.",
        "notFound": "Business Unit record not found"
      },
      "add": "Add Business Unit",
      "delete": {
        "title": "Delete Business Unit",
        "text": "Are you sure you want to delete this Business Unit?"
      }
    },
    "division": {
      "menuName": "Division",
      "pageTitle": "Division",
      "id": "Id",
      "externalId": "External Id",
      "description": "Description",
      "isActive": "Is Active",
      "businessUnitId": "Business Unit",
      "edit": "Edit Division",
      "messages": {
        "created": "Division created successfully.",
        "updated": "Division updated successfully.",
        "deleted": "Division deleted successfully."
      },
      "add": "Add Division",
      "delete": {
        "title": "Delete Division",
        "text": "Are you sure you want to delete this Division?"
      }
    },
    "organization": {
      "menuName": "Organization",
      "pageTitle": "Organization",
      "id": "Id",
      "externalId": "External Id",
      "name": "Name",
      "plantAreaId": "Plant Area",
      "organizationParentId": "Parent Organization",
      "edit": "Edit Organization",
      "messages": {
        "created": "Organization created successfully.",
        "updated": "Organization updated successfully.",
        "deleted": "Organization deleted successfully."
      },
      "add": "Add Organization",
      "delete": {
        "title": "Delete Organization",
        "text": "Are you sure you want to delete this Organization?"
      }
    },
    "plant": {
      "menuName": "Plant",
      "pageTitle": "Plant",
      "id": "Id",
      "name": "Name",
      "alias": "Alias",
      "isActive": "Is Active",
      "divisionId": "Division",
      "countryId": "Country",
      "employeeCanUpdateGoals": "Employee Can Update Goals",
      "employeeCanUpdateTracks": "Employee Can Update Actuals",
      "employeeCanIncludeKPI": "Employee Can Create KPI",
      "managerCanUpdateGoals": "Manager Can Update Goals",
      "managerCanUpdateTracks": "Manager Can Update Actuals",
      "managerCanIncludeKPI": "Manager Can Create KPI",
      "edit": "Edit Plant",
      "messages": {
        "created": "Plant created successfully.",
        "updated": "Plant updated successfully.",
        "deleted": "Plant deleted successfully.",
        "inUse": "Plant record is in use. First delete its uses.",
        "notFound": "Plant record not found",
        "duplicated": "A plant with this alias already exists."
      },
      "add": "Add Plant",
      "delete": {
        "title": "Delete Plant",
        "text": "Are you sure you want to delete this Plant?"
      }
    },
    "personnelArea": {
      "menuName": "Personnel Area",
      "pageTitle": "Personnel Area",
      "id": "Id",
      "description": "Description",
      "externalId": "External Id",
      "plantId": "Plant",
      "isActive": "Is Active",
      "sourceModifiedDate": "Source Modified Date",
      "edit": "Edit Personnel Area",
      "messages": {
        "created": "Personnel Area created successfully.",
        "updated": "Personnel Area updated successfully.",
        "deleted": "Personnel Area deleted successfully.",
        "inUse": "Personnel Area record is in use. First delete its uses.",
        "notFound": "Personnel Area record not found",
        "alreadyExists": "A personnel area with this description already exists.",
        "fileRequired": "The file is required.",
        "importError": "An error occurred while importing the personnel area.",
        "invalidPlant": "Invalid Plant Id",
        "duplicateExternalId": "Duplicated ExternalId",
        "importSuccess": "Personnel Area imported successfully. You'll receive the file by email",
        "exportSuccess": "Personnel Area exported successfully. You'll receive the file by email",
        "exportFailed": "Failed to export personnel area.",
        "importFailed": "Failed to import personnel area.",
        "personNotFound": "Person not found to do the import. Contact Admin.",
        "emailNotFound": "Email not found to do the import. Contact Admin.",
        "importFalied": "Import of personnel area falied."
      },
      "add": "Add Personnel Area",
      "delete": {
        "title": "Delete Personnel Area",
        "text": "Are you sure you want to delete this Personnel Area?"
      }
    },
    "position": {
      "menuName": "Position",
      "pageTitle": "Position",
      "id": "Id",
      "description": "Description",
      "externalId": "External Id",
      "active": "Active",
      "jobCode": "Job",
      "jobId": "Job",
      "organizationId": "Organization",
      "employeeSubGroupId": "Employee Sub Group",
      "costCenterId": "Cost Center",
      "salaryLevelId": "Salary Level",
      "businessAreaId": "Business Area",
      "bonusFrequencyId": "Bonus Frequency",
      "personnelAreaCode": "Personnel Area",
      "payGradeType": "Pay Grade Type",
      "payGradeArea": "Pay Grade Area",
      "employeeGroupId": "Employee Group",
      "salaryGroupId": "Salary Group",
      "minimum": "Minimum",
      "midpoint": "MidPoint",
      "edit": "Edit Position Area",
      "messages": {
        "created": "Position created successfully.",
        "updated": "Position updated successfully.",
        "inUse": "Position record is in use. First delete its uses.",
        "notFound": "Position record not found",
        "duplicated": "A position with this externalId/Name already exists."
      },
      "add": "Add Position"
    },
    "configuration": {
      "menuName": "Configuration",
      "pageTitle": "Configuration",
      "key": "Key",
      "value": "Value",
      "editorType": "Type",
      "add": "Add Configuration",
      "edit": "Edit Configuration",
      "delete": {
        "title": "Delete Configuration",
        "text": "Are you sure you want to delete this configuration?"
      },
      "messages": {
        "created": "Configuration created successfully.",
        "updated": "Configuration updated successfully.",
        "deleted": "Configuration deleted successfully."
      },
      "types": {
        "text": "Text",
        "string": "String",
        "number": "Number",
        "int": "Integer",
        "boolean": "Boolean"
      }
    },
    "positionProfile": {
      "pageTitle": "Critical Position",
      "globalCritical": "Global Critical",
      "countryCritical": "Country Critical",
      "businessUnitCritical": "Business Unit Critical",
      "positionType": "Position Type",
      "sucessorType": "Sucessor Type",
      "potentialSuccessorType": "Sucessor Type",
      "potentialSuccessorId": "Potential Successor",
      "readinessFactor": "Readiness Factor",
      "potentialSuccessorName": "Name",
      "potentialSuccessorCompany": "Company",
      "potentialSuccessorLinkedIn": "LinkedIn URL",
      "potentialSuccessorNotes": "Notes",
      "messages": {
        "created": "Critical Position created successfully.",
        "updated": "Critical Position updated successfully."
      }
    },
    "widget": {
      "menuName": "Widget",
      "pageTitle": "Widget",
      "name": "Name",
      "description": "Description",
      "securityResources": "Security Resources",
      "link": "Link",
      "query": "SQL Query",
      "queryRequired": "SQL Query is required.",
      "sqlQueryDateFormatInfo": "Date columns must be formatted in mm/DD/yyyy format.",
      "minHeight": "Minimum Height",
      "minWidth": "Minimum Width",
      "autoApplied": "Apply to all dashboards",
      "autoAppliedHelp": "This will force this widget onto all dashboards, and users will keep seeing it even if they try to remove it.",
      "type": "Type",
      "category": "Category",
      "add": "Add Widget",
      "edit": "Edit Widget",
      "delete": {
        "title": "Delete Widget",
        "text": "Are you sure you want to delete this widget?"
      },
      "examples": {
        "viewSQLExamples": "View SQL examples",
        "general": "General",
        "generalDescription": "By default, the system provides the following parameters, which can be referenced directly in any widget SQL query.",
        "loggedUserNameDescription": "Login username of the currently logged-in user (for example: {email}).",
        "loggedUserEmployeeIdDescription": "Employee identifier of the currently logged-in user.",
        "loggedUserLanguageDescription": "Language code of the currently logged-in user (for example: en-US, pt-BR).",
        "loggedUserUniqueIdDescription": "User's unique id (Guid)",
        "loggedUserEncryptedUniqueIdDescription": "Encrypted User's unique id",
        "listDescription": "Each row represents one list item.",
        "numberDescription": "Returns a single numeric value.",
        "donutDescription": "Labels and values must align by position.",
        "lineDescription": "Each row represents one line series."
      },
      "messages": {
        "created": "Widget created successfully.",
        "updated": "Widget updated successfully.",
        "deleted": "Widget deleted successfully.",
        "fileRequired": "The file is required.",
        "importError": "An error occurred while importing the widget.",
        "queryVariablesMissing": "The following variables are missing in the widget query: \"{variables}\". Please add them to the query to ensure proper functionality."
      }
    },
    "reportColumnTemplate": {
      "menuName": "Report Column Templates",
      "pageTitle": "Report Column Templates",
      "id": "ID",
      "description": "Description",
      "template": "Template",
      "templateHelp": "Use {value} as a placeholder for the cell value. HTML is supported.",
      "add": "Add Template",
      "edit": "Edit Template",
      "delete": {
        "title": "Delete Template",
        "text": "Are you sure you want to delete \"{name}\"?"
      },
      "messages": {
        "created": "Template created successfully.",
        "updated": "Template updated successfully.",
        "deleted": "Template deleted successfully."
      }
    },
    "widgetCategory": {
      "menuName": "Widget Category",
      "pageTitle": "Widget Category",
      "name": "Name",
      "description": "Description",
      "type": "Type",
      "add": "Add Widget Category",
      "edit": "Edit Widget Category",
      "delete": {
        "title": "Delete Widget Category",
        "text": "Are you sure you want to delete this widget category?"
      },
      "messages": {
        "created": "Widget Category created successfully.",
        "updated": "Widget Category updated successfully.",
        "deleted": "Widget Category deleted successfully."
      }
    },
    "widgetType": {
      "menuName": "Widget Type",
      "pageTitle": "Widget Type",
      "name": "Name",
      "types": {
        "number": "Number",
        "list": "List",
        "donut": "Donut",
        "line": "Line"
      }
    },
    "widgetParameter": {
      "menuName": "Widget Parameter",
      "menuTitle": "Widget Parameter",
      "title": "Widget Parameter",
      "name": "Name",
      "nameInfo": "Name used to identify the parameter in the widget SQL query. Don't use spaces or special characters.",
      "nameUniqueError": "A Widget Parameter with this name already exists.",
      "description": "Description",
      "isRequired": "Is Required?",
      "isMultiple": "Is Multiple?",
      "status": "Status",
      "edit": "Edit Widget Parameter",
      "add": "Add Widget Parameter",
      "type": "Type",
      "data": "SQL Query",
      "dataInfo": "The SQL query must return two columns named 'Value' and 'Text'.",
      "listOfValues": "List of Values",
      "addValue": "Add Value",
      "value": "Value",
      "label": "Label",
      "delete": {
        "title": "Delete Widget Parameter",
        "text": "Are you sure you want to delete {name}?"
      },
      "types": {
        "text": "Text",
        "number": "Number",
        "date": "Date",
        "boolean": "Boolean",
        "select": "List",
        "sql": "Query List"
      },
      "messages": {
        "notFound": "Widget Parameter not found.",
        "saveSuccess": "Widget Parameter saved successfully.",
        "saveError": "An error occurred while saving the Widget Parameter.",
        "deleteSuccess": "Widget Parameter deleted successfully.",
        "deleteError": "An error occurred while deleting the Widget Parameter.",
        "isInUse": "Cannot delete Widget Parameter because it's in use."
      }
    },
    "people": {
      "menuName": "People",
      "pageTitle": "People",
      "employeeId": "Employee Id",
      "person": "Person",
      "id": "Id",
      "name": "Name",
      "email": "Email",
      "externalId": "External Id",
      "status": "Status",
      "type": "Type",
      "positionShortDescription": "Position Short Description",
      "hireDate": "Hire Date",
      "culture": "Culture",
      "sourceJTPInstance": "Source JTP Code",
      "documentId": "Document Id",
      "manager": "Manager",
      "position": "Position",
      "bonusFrequency": "Bonus Frequency",
      "businessArea": "Business Area",
      "personnelArea": "Personnel Area",
      "division": "Division",
      "plant": "Plant",
      "businessUnit": "Business Unit",
      "shiftId": "Shift",
      "plantAreaId": "Plant Area",
      "customerSpecificStatus": "Customer Specific Status",
      "vendorNumber": "Vendor Number",
      "accountNumber": "Account Number Last 4",
      "overrideManagerId": "Override Manager",
      "requirePrivacyConsent": "Global Employee",
      "globalDirectReports": "Global Direct Reports",
      "globalManagerOverrideHelpText": "Selected employees will report to this employee only in a global scale. If this employee has direct reports, all directs will be flagged as global as well",
      "messages": {
        "updated": "Person updated successfully.",
        "notFound": "Person record not found",
        "alreadyExists": "A person with this description already exists.",
        "fileRequired": "The file is required.",
        "importError": "An error occurred while importing the people.",
        "importSuccess": "People imported successfully. You'll receive the file by email",
        "importFailed": "Failed to import people.",
        "personNotFound": "Person not found to do the import. Contact Admin.",
        "emailNotFound": "Email not found to do the import. Contact Admin.",
        "importFalied": "Import of people falied."
      },
      "personTypes": {
        "unknown": "Unknown",
        "salariedEmployee": "Salaried Employee",
        "contractor": "Contractor",
        "vendor": "Vendor",
        "hourlyEmployee": "Hourly Employee",
        "external": "External",
        "duHourlyInactive": "DU Hourly Inactive",
        "duSalariedInactive": "DU Salaried Inactive",
        "duTruckDriverIn": "DU Truck Driver In",
        "executive": "Executive",
        "union": "Union",
        "nonUnion": "Non Union",
        "unionPossible": "Union Possible",
        "salariedNonExempt": "Salaried Non Exempt",
        "hourly": "Hourly",
        "duPaidLeave": "DU Paid Leave",
        "truckDriver": "Truck Driver",
        "duUnpaidLeave": "DU Unpaid Leave",
        "workRelease": "Work Release",
        "externalAccessLevelOne": "External Access Level One",
        "externalAccessLevelTwo": "External Access Level Two",
        "externalAccessLevelThree": "External Access Level Three",
        "externalAccessLevelFour": "External Access Level Four",
        "externalAccessLevelFive": "External Access Level Five",
        "globalEmployee": "Global Employee"
      },
      "customerSpecificStatuses": {
        "unknown": "Unknown",
        "active": "Active",
        "inactive": "Inactive",
        "incomeAssistance": "Income Assistance",
        "lOA": "Leave of Absence",
        "retiree": "Retiree",
        "withdrawn": "Withdrawn"
      }
    },
    "companyCode": {
      "menuName": "Company Codes"
    },
    "costCenter": {
      "menuName": "Cost Centers"
    },
    "currency": {
      "menuName": "Currencies"
    },
    "exchangeRate": {
      "menuName": "Exchange Rates"
    }
  },
  "threeHundredSixty": {
    "menuTitle": "360",
    "questionOption": {
      "menuTitle": "Rating Scales",
      "pageTitle": "Rating Scales",
      "description": "Description",
      "add": "Add Rating Scale",
      "edit": "Edit Rating Scale",
      "delete": {
        "title": "Delete Rating Scale",
        "text": "Are you sure you want to delete this rating scale?"
      },
      "messages": {
        "notFound": "Rating Scale not found.",
        "saveSuccess": "Rating Scale saved successfully.",
        "saveError": "An error occurred while saving the Rating Scale.",
        "deleteSuccess": "Rating Scale deleted successfully.",
        "deleteError": "An error occurred while deleting the Rating Scale.",
        "isInUse": "Cannot delete Rating Scale because it's in use.",
        "duplicateName": "A rating scale with this description already exists."
      },
      "options": {
        "title": "Options",
        "value": "Value",
        "description": "Description",
        "explanation": "Explanation",
        "itemOrder": "Order",
        "color": "Color",
        "commentConfig": "Comment Configuration",
        "add": "Add Option",
        "edit": "Edit Option",
        "delete": {
          "title": "Delete Option",
          "text": "Are you sure you want to delete this option?"
        },
        "messages": {
          "created": "Option created successfully.",
          "updated": "Option updated successfully.",
          "deleted": "Option deleted successfully.",
          "notFound": "Option not found.",
          "duplicateValue": "Two or more options have the same value. Each option must have a unique value.",
          "duplicateDescription": "Two or more options have the same description. Each option must have a unique description."
        },
        "commentConfigType": {
          "followForm": "Follow Form",
          "required": "Required",
          "notRequired": "Not Required"
        }
      }
    },
    "questionGroup": {
      "menuTitle": "Question Groups",
      "pageTitle": "Question Groups",
      "name": "Name",
      "description": "Description",
      "add": "Add Question Group",
      "edit": "Edit Question Group",
      "delete": {
        "title": "Delete Question Group",
        "text": "Are you sure you want to delete this question group: {name}?"
      },
      "messages": {
        "notFound": "Question Group not found.",
        "saveSuccess": "Question Group saved successfully.",
        "saveError": "An error occurred while saving the Question Group.",
        "deleteSuccess": "Question Group deleted successfully.",
        "deleteError": "An error occurred while deleting the Question Group.",
        "isInUse": "Cannot delete Question Group because it's in use."
      }
    },
    "question": {
      "menuTitle": "Questions",
      "pageTitle": "Questions",
      "name": "Name",
      "weight": "Weight",
      "commentDisabled": "Comment Disabled",
      "description": "Description",
      "questionGroup": "Question Group",
      "questionOption": "Rating Scale",
      "add": "Add Question",
      "edit": "Edit Question",
      "delete": {
        "title": "Delete Question",
        "text": "Are you sure you want to delete this question?"
      },
      "messages": {
        "notFound": "Question not found.",
        "saveSuccess": "Question saved successfully.",
        "saveError": "An error occurred while saving the Question.",
        "deleteSuccess": "Question deleted successfully.",
        "deleteError": "An error occurred while deleting the Question.",
        "isInUse": "Cannot delete Question because it's in use."
      }
    },
    "formCategory": {
      "menuTitle": "Form Categories",
      "pageTitle": "Form Categories",
      "name": "Name",
      "description": "Description",
      "add": "Add Form Category",
      "edit": "Edit Form Category",
      "delete": {
        "title": "Delete Form Category",
        "text": "Are you sure you want to delete this form category?"
      },
      "messages": {
        "notFound": "Form Category not found.",
        "saveSuccess": "Form Category saved successfully.",
        "saveError": "An error occurred while saving the Form Category.",
        "deleteSuccess": "Form Category deleted successfully.",
        "deleteError": "An error occurred while deleting the Form Category.",
        "isInUse": "Cannot delete Form Category because it's in use."
      }
    },
    "formDelegate": {
      "menuTitle": "Form Delegate",
      "pageTitle": "Form Delegate",
      "form": "Form",
      "manager": "Manager",
      "delegate": "Delegate",
      "add": "Add Form Delegate",
      "edit": "Edit Form Delegate",
      "delegatedToPerson": "Delegate to",
      "invitedEnabled": "Invite Enabled",
      "signEnabled": "Sign Enabled",
      "resultViewerEnabled": "Result Viewer Enabled",
      "delete": {
        "title": "Delete Form Delegate",
        "text": "Are you sure you want to delete this form delegate?"
      },
      "messages": {
        "notFound": "Form Delegate not found.",
        "saveSuccess": "Form Delegate saved successfully.",
        "saveError": "An error occurred while saving the Form Delegate.",
        "deleteSuccess": "Form Delegate deleted successfully.",
        "deleteError": "An error occurred while deleting the Form Delegate.",
        "managerDisabledMessage": "You don't have access to this form"
      }
    },
    "formDelegateGlobal": {
      "menuTitle": "Global Form Delegate",
      "pageTitle": "Global Form Delegate"
    },
    "form": {
      "menuTitle": "Forms",
      "pageTitle": "Forms",
      "id": "Id",
      "description": "Description",
      "category": "Category",
      "categoryId": "Category",
      "stage": {
        "label": "Stage",
        "preparation": "Preparation",
        "execution": "Execution",
        "managerReview": "Manager Review",
        "participantReview": "Participant Review",
        "closed": "Closed"
      },
      "active": "Active",
      "maximumHireDate": "Maximum Hire Date",
      "maxPeopleEvaluateAlert": "Max People Evaluate Alert",
      "includeGlobalReporting": "Global Reporting",
      "customerSpecificStatus": "Customer Specific Status",
      "employeeType": "Employee Type",
      "reportType": {
        "label": "Report Type",
        "question": "By Question",
        "questionGroup": "By Question Group"
      },
      "directReportBox": "Direct Report",
      "selfEvaluationBox": "Self Evaluation",
      "managerEvaluationBox": "Manager Evaluation",
      "crossGroupEvaluationBox": "Cross Group Evaluation",
      "freeEvaluationBox": "Free Evaluation",
      "dueDatesBox": "Due Dates",
      "evaluation": "Evaluation",
      "comments": "Comments",
      "weight": "Weight",
      "minCrossGroupEvaluations": "Min Cross Group Evaluations",
      "crossGroupDueDate": "Create Cross Group – Self",
      "evaluationDueDate": "Create Cross Group – Manager",
      "managerSignDueDate": "Final Cross Group – Manager",
      "participantSignDueDate": "Close Date",
      "processDueDate": "Evaluation",
      "beginningReviewDate": "Beginning Review Period",
      "endingReviewDate": "Ending Review Period",
      "maxReleaseQuestionnaireDate": "Release Questionnaire",
      "createdBy": "Created By",
      "createdDate": "Created Date",
      "modifiedBy": "Modified By",
      "modifiedDate": "Modified Date",
      "maximumHireDateHelpText": "Maximum hire date of the employee to participate, except if the employee is a manager.",
      "maxPeopleEvaluateAlertHelpText": "Show an alert after the employee reaches the number of max people to evaluate",
      "includeGlobalReportingHelpText": "Include in Global Reporting",
      "directReportEvaluationHelpText": "Direct Report Evaluation",
      "directReportCommentsHelpText": "Direct Report Comments",
      "directReportWeightHelpText": "Direct Report Weight",
      "selfEvaluationHelpText": "Self Evaluation",
      "selfCommentsHelpText": "Self Comments",
      "selfWeightHelpText": "Self Weight",
      "managerEvaluationHelpText": "Manager Evaluation",
      "managerCommentsHelpText": "Manager Comments",
      "managerWeightHelpText": "Manager Weight",
      "freeCommentsHelpText": "Free Comments",
      "freeWeightHelpText": "Free Weight",
      "crossGroupEvaluationHelpText": "Cross Group Evaluation",
      "crossGroupCommentsHelpText": "Cross Group Comments",
      "crossGroupWeightHelpText": "Cross Group Weight",
      "minCrossGroupEvaluationsHelpText": "Minimum number of cross group evaluations to allow the manager to release the questionnaire.",
      "maxReleaseQuestionnaireDateHelpText": "Maximum date for manager to release questionnaire",
      "add": "Add Form",
      "edit": "Edit Form",
      "updateCounters": "Update Counters",
      "detailedResult": "Detailed Result",
      "move": {
        "button": "Move To {stage}",
        "title": "Move Step",
        "text": "Are you sure you want to move this form to stage {stage}?"
      },
      "duplicate": {
        "button": "Duplicate",
        "title": "Duplicate Form",
        "text": "Are you sure you want to duplicate this form?"
      },
      "delete": {
        "title": "Delete Form",
        "text": "Are you sure you want to delete this form: {name}?"
      },
      "formQuestion": {
        "title": "Form Questions",
        "question": "Question",
        "itemOrder": "Order",
        "questionGroup": "Question Group",
        "add": "Add Question",
        "edit": "Edit Question",
        "delete": {
          "title": "Delete Question",
          "text": "Are you sure you want to delete {name} from this form?"
        },
        "messages": {
          "saveSuccess": "Form Question saved successfully.",
          "saveError": "An error occurred while saving the Form Question.",
          "deleteSuccess": "Form Question deleted successfully.",
          "deleteError": "An error occurred while deleting the Form Question.",
          "duplicateQuestion": "This question is already added to the form.",
          "notFound": "Form Question not found.",
          "questionNotFound": "Question not found."
        }
      },
      "messages": {
        "notFound": "Form not found.",
        "saveSuccess": "Form saved successfully.",
        "saveError": "An error occurred while saving the Form.",
        "deleteSuccess": "Form deleted successfully.",
        "deleteError": "An error occurred while deleting the Form.",
        "isInUse": "Cannot delete Form because it's in use.",
        "atLeastOneMemberEvaluate": "At least one evaluator type (Direct Report, Self, Manager, or Cross Group) must be enabled.",
        "maximumHireDateRequired": "Maximum Hire Date is required.",
        "dueDatesRequired": "All due dates are required.",
        "moveStageSuccess": "Form moved to the next stage successfully.",
        "moveStageNotAllowed": "Cannot move a closed form to another stage.",
        "moveStageNotAllowedNoPeople": "Form has no people. To move, visit the Form People page to include people on this form.",
        "moveStageNotAllowedNoQuestions": "Form has no questions. To move, insert at least one question.",
        "duplicateSuccess": "Form duplicated successfully.",
        "updateCountersSuccess": "Counters update has been triggered.",
        "detailedResultSuccess": "Detailed result generation has been triggered."
      }
    },
    "formEmailSender": {
      "menuTitle": "Form Email Sender",
      "pageTitle": "Form Email Sender",
      "messages": {
        "emailsSent": "Emails sent successfully."
      }
    },
    "questionnaire": {
      "questionnaireTypes": {
        "manager": "Manager",
        "directReport": "Direct Report",
        "crossGroup": "Cross Group",
        "selfEvaluation": "Self Evaluation",
        "freeEvaluation": "Free Evaluation"
      },
      "questionnaireRequestTypes": {
        "default": "Default",
        "manager": "Manager",
        "directReport": "Direct Report"
      },
      "questionnaireStatus": {
        "done": "Done",
        "declined": "Declined",
        "open": "Open"
      },
      "questionnairePriorityTypes": {
        "selfDirectManager": "Self, Directs & Manager",
        "crossGroupPeers": "Cross Group (Peers)",
        "crossGroup": "Cross Groups",
        "freeEvaluation": "Free Evaluation"
      },
      "questionnairesReport": {
        "title": "Questionnaires Report",
        "messages": {
          "confirm": "File will be exported. You'll receive the results by email soon.",
          "success": "Questionnaires report export has been triggered. You'll receive the results by email soon.",
          "emailNotFound": "Email not found to do the export. Contact Admin.",
          "formNotFound": "Form not found to do the export. Contact Admin.",
          "exportFailed": "Failed to export questionnaires report."
        }
      },
      "createCrossGroupForMyself": {
        "menuTitle": "Create Cross Group for Myself",
        "pageTitle": "Create Cross Group for Myself",
        "form": "Form",
        "infoMessage": " Below is your default cross group. Add additional direct reports that you'd like to be evaluated by. You must have at least five labeled \"cross group\" type. Your manager will review, update accordingly and release questionnaires.",
        "warningReleasedQuestionnaires": "You are not able to add cross groups because your manager already released questionnaires about you. Please, talk with him about adding more questionnaires.",
        "add": "Add Direct Report",
        "evaluatorPerson": "Evaluator",
        "manager": "Manager",
        "type": "Type",
        "requestType": "Requested By",
        "released": "Released",
        "status": "Status",
        "actions": "Actions",
        "delete": {
          "title": "Delete Questionnaire",
          "text": "Are you sure you want to delete this questionnaire?"
        },
        "messages": {
          "alreadyExists": "This questionnaire already exists for {names}. If you have any questions, please talk to your manager.",
          "addSuccess": "Questionnaires created successfully.",
          "deleteSuccess": "Questionnaire deleted successfully.",
          "invitedPersonWarning": "{names} has already been invited to provide 360 feedback on at least {limit} other forms. To include them in additional forms select 'Save'. If their feedback is not essential, close without saving and select another person to provide feedback."
        }
      },
      "crossGroupForMyTeam": {
        "menuTitle": "Create Cross Groups for My Team",
        "pageTitle": "Create Cross Groups for My Team",
        "form": "Form",
        "manager": "Manager",
        "evaluatedPerson": "Evaluated",
        "evaluatorPerson": "Evaluator",
        "type": "Type",
        "released": "Released",
        "status": "Status",
        "loadCrossGroupDefaults": "Load Cross-Group Defaults",
        "unloadCrossGroupDefaults": "Unload Cross-Group Defaults",
        "releaseQuestionnaire": "Release Questionnaires",
        "add": "Add Questionnaire",
        "delete": {
          "title": "Delete Questionnaire",
          "text": "Are you sure you want to delete this questionnaire?"
        },
        "messages": {
          "alreadyExists": "This questionnaire already exists for {names}. If you have any questions, please talk to your manager.",
          "createdSuccess": "Questionnaires created successfully.",
          "deletedSuccess": "Questionnaire deleted successfully.",
          "saveError": "An error occurred while saving the questionnaire. Please try again.",
          "questionnairesAlreadyExists": "Questionnaires already exist for: {names}.",
          "managerDisabledMessage": "You don't have access to this cross group form",
          "releasedSuccess": "Questionnaires released successfully.",
          "minCrossGroupEvaluations": "Only people with at least {value} cross group questionnaires are displayed.",
          "noQuestionnairesToRelease": "There are no questionnaires to release. Please add at least one questionnaire to release.",
          "isReadOnlyDueStage": "This form is read only and cannot be edited",
          "remoteInstanceWarning": "Some problem occurred while loading remote information.",
          "minimumCrossGroupsNotMet": "Direct Report does not have the minimum number of crossgroups ({current}/{minimum})",
          "questionnairesReleased": "Questionnaires Released",
          "readyForRelease": "Ready for release"
        },
        "crossGroupDefaults": {
          "loadDefaults": {
            "title": "Load Cross Group Defaults",
            "messages": {
              "confirm": "WARNING: Please confirm you would like to load the default cross group participants for all direct reports.",
              "success": "Default cross group participants loaded successfully."
            }
          },
          "unloadDefaults": {
            "title": "Unload Cross Group Defaults",
            "messages": {
              "confirm": "Please confirm you would like to unload the default cross group participants for all direct reports.",
              "success": "Default cross group participants unloaded successfully."
            }
          }
        }
      },
      "crossGroupForMyRemoteTeam": {
        "menuTitle": "Create Cross Groups for My Global Team",
        "pageTitle": "Create Cross Groups for My Global Team"
      },
      "complete": {
        "menuTitle": "Complete Evaluations",
        "pageTitle": "Complete Evaluations",
        "form": "Form",
        "questionnaireType": "Questionnaire Type",
        "submit": "Submit",
        "notApplicable": "N/A",
        "reopen": "Reopen",
        "status": {
          "new": "Questionnaire not started",
          "inProgress": "Questionnaire in progress",
          "completed": "Questionnaire completed"
        },
        "notApplicableTitle": "Decline questionnaire",
        "reopenTitle": "Confirm pull back",
        "addFreeEvaluation": "Add Free Evaluation",
        "personToEvaluate": "Person to Evaluate",
        "freeEvaluationWarning": "Free Evaluations will need to be approved by managers and do not contribute to overall 360 scores.",
        "messages": {
          "loading": "Loading questionnaires...",
          "loadingGlobalQuestionnaires": "Loading global questionnaires...",
          "formNotFound": "Form not found.",
          "employeeNotFound": "Employee not found.",
          "freeEvaluationNotAllowed": "You cannot add a free evaluation for yourself, your manager, your peers or your directs.",
          "alreadyExists": "An evaluation for this person already exists.",
          "submitConfirmation": "By clicking submit, the displayed employee rating is what will be recorded. You may withdraw submitted evaluations until the 360 process advances to manager sign.",
          "summaryValidate": "Validate answers and scroll down to submit. Clicking the X in the top right corner will not finalize your submission.",
          "submitSuccess": "Questionnaire submitted successfully.",
          "questionnaireNotFound": "Questionnaire not found.",
          "notSubmittedWarningMessage": "This questionnaire is not submitted yet and it's not being considered in the employee's score.",
          "noQuestionnaires": "You don't have any questionnaires to complete.",
          "selectQuestionnaire": "Select a questionnaire to complete.",
          "employeeRateSummary": "Employee's Rate: ",
          "notApplicable": "If you are not the appropriate person to complete this performance review, you may decline the responsibility, after providing a reason.",
          "declineSuccess": "Questionnaire declined successfully.",
          "requiredQuestionnairesCompleted": "All remaining evaluations can be completed at your discretion.",
          "allQuestionsRequired": "All questions and comments are required in order to submit.",
          "confirmReopen": "Are you sure that you want to pull back the evaluation for {name}?",
          "reopenSuccess": "Questionnaire reopened successfully.",
          "questionnaireAlreadySubmitted": "This questionnaire has already been submitted and cannot be edited.",
          "addFreeEvaluationSuccess": "Free evaluation added successfully."
        }
      },
      "freeEvaluation": {
        "menuTitle": "Free Evaluation Review",
        "menuTitleGlobal": "Global Free Evaluation Review",
        "pageTitle": "Free Evaluation Review",
        "pageTitleGlobal": "Global Free Evaluation Review",
        "evaluatedPerson": "Evaluated",
        "view": "View Questionnaire",
        "infoMessage": "Please review the questionnaires below and approve the ones you agree with. If you do not approve a questionnaire, no further action is required.",
        "messages": {
          "confirmApproval": "Are you sure you want to approve the questionnaire?",
          "approvalSuccess": "Questionnaire approved successfully.",
          "notFound": "Questionnaire not found."
        }
      }
    },
    "formPeople": {
      "participants": {
        "menuTitle": "Form Participants",
        "pageTitle": "Form Participants",
        "formId": "Form",
        "resetTree": "Reset Tree",
        "resetTreeTitle": "Reset Tree",
        "resetTreeText": "Are you sure you want to reset the tree?",
        "addPerson": "Add Participant",
        "changeManager": "Change Manager",
        "moveToAnotherManager": "Move to another manager",
        "downloadTemplate": "Download Template",
        "import": "Import",
        "person": "Employee",
        "currentManager": "Current Manager",
        "newManager": "New Manager",
        "messages": {
          "noNodeSelected": "You need to select at least one employee.",
          "saveSuccess": "Form participants saved successfully.",
          "resetSuccess": "Form participants reset successfully.",
          "formNotFound": "Form not found.",
          "selectEmployee": "Select an employee first",
          "addPersonSuccess": "Person added successfully.",
          "changeManagerSuccess": "Manager changed successfully.",
          "moveToManagerSuccess": "Person moved to new manager successfully.",
          "managerNotInTree": "Selected manager is not in the tree.",
          "circularManagerSelection": "Cannot move an employee to one of their own reports.",
          "importSuccess": "File imported successfully. You'll receive the results by email soon."
        },
        "errors": {
          "formInExecution": "This action can't be performed because the form is currently in execution."
        }
      },
      "resultViewer": {
        "menuTitle": "Approved PDF Reports",
        "pageTitle": "Approved PDF Reports",
        "person": "Person",
        "personHelpText": "You can select you or any of your direct reports.",
        "personMultipleInstance": "Do not select employees from multiple instances. Results may be incorrect or incomplete.",
        "manager": "Manager",
        "form": "Form",
        "position": "Position",
        "managerFeedback": "Manager Feedback",
        "employeeFeedback": "Employee Feedback",
        "pdfReport": "PDF Report",
        "pdfReportFreeEvaluation": "Free Evaluation PDF",
        "pdfReportFreeEvaluationNonApproved": "Non-Approved Free Evaluation PDF",
        "downloadSelected360Report": "Download Selected 360 Report",
        "downloadSelectedFreeEvaluationReport": "Download Selected Free Evaluation Report",
        "downloadSelectedNonApprovedFreeEvaluationReport": "Download Selected Non-Approved Free Evaluation Report",
        "emailSelected360Report": "Download Selected 360 Report",
        "emailSelectedFreeEvaluationReport": "Download Selected Free Evaluation Report",
        "emailSelectedNonApprovedFreeEvaluationReport": "Download Selected Non-Approved Free Evaluation Report",
        "bulkEmailQueued": "Your reports are being prepared. You will receive an email with the PDF attachments shortly.",
        "bulkEmailNoSelection": "Select at least one row.",
        "bulkEmailInvalidSelection": "One or more selected rows are not valid for your access.",
        "bulkEmailNoReportForKind": "The selected rows do not include this report type.",
        "showFeedback": "Show Feedback",
        "downloadEvaluationSelectOne": "Select one person or manager.",
        "validationSelectPersonOrManager": "Select a person or manager to run the filter.",
        "successPdfByEmail": "The PDF was sent successfully to your email."
      },
      "sign": {
        "menuTitle": "Sign Pending Evaluations",
        "pageTitle": "Sign Pending Evaluations",
        "menuTitleGlobal": "Global Sign Pending Evaluations",
        "pageTitleGlobal": "Global Sign Pending Evaluations",
        "form": "Form",
        "managerOrPerson": "Manager/Person",
        "person": "Person",
        "pdfReport": "PDF Report",
        "pdfReportFreeEvaluation": "Free Evaluations PDF Report",
        "sign": "Sign",
        "signed": "Signed",
        "signTitle": "Sign Evaluation",
        "managerSign": "Manager Sign",
        "personSign": "Employee Sign",
        "signatureComments": "Signature Comments",
        "updateComment": "Update Comment",
        "messages": {
          "signedBy": "Signed by {name} on {date}",
          "signConfirmationManager": "Any additional information regarding the feedback process with your direct report can be provided below.",
          "signConfirmationPerson": "By selecting sign, you confirm that you had a feedback conversation with your manager about the evaluation.",
          "signConfirmationWarning": "By selecting sign, the PDF will be released to the employee.",
          "managerSignatureNotAllowed": "You cannot sign this evaluation because manager already signed it.",
          "employeeSignatureNotAllowed": "You cannot sign this evaluation because person already signed it.",
          "successMessage": "Evaluation signed successfully.",
          "updateCommentSuccessMessage": "Comment updated successfully.",
          "noComments": "You must provide comments before signing."
        }
      }
    }
  },
  "security": {
    "menuTitle": "Security",
    "resource": {
      "menuName": "Resource",
      "pageTitle": "Resource",
      "add": "Add Resource",
      "edit": "Edit Resource",
      "delete": {
        "title": "Delete Resource",
        "text": "Are you sure you want to delete this resource?"
      },
      "id": "Id",
      "name": "Name",
      "description": "Description",
      "resourceType": "Resource Type",
      "isActive": "Is Active",
      "messages": {
        "created": "Resource created successfully.",
        "updated": "Resource updated successfully.",
        "deleted": "Resource deleted successfully.",
        "notFound": "Resource record not found",
        "duplicateName": "A resource with this name already exists.",
        "inUse": "Resource record is in use. First delete its uses."
      }
    },
    "user": {
      "menuName": "User",
      "pageTitle": "User",
      "subgridName": "User Account",
      "uniqueId": "Unique Id",
      "add": "Add User Account",
      "edit": "Edit User Account",
      "delete": {
        "title": "Delete User Account",
        "text": "Are you sure you want to delete this user account?"
      },
      "personId": "Id",
      "provider": "Provider",
      "userName": "User Name",
      "isActive": "Is Active",
      "messages": {
        "created": "User Account created successfully.",
        "updated": "User Account updated successfully.",
        "deleted": "User Account deleted successfully.",
        "notFound": "User Account record not found",
        "duplicateName": "This userName already exists."
      }
    },
    "group": {
      "menuName": "Group",
      "pageTitle": "Group",
      "add": "Add Group",
      "edit": "Edit Group",
      "delete": {
        "title": "Delete Group?",
        "text": "Are you sure you want to delete this group?"
      },
      "id": "Id",
      "name": "Name",
      "description": "Description",
      "isActive": "Is Active",
      "overwriteGroups": "Overwrite Groups",
      "messages": {
        "created": "Group created successfully.",
        "updated": "Group updated successfully.",
        "deleted": "Group deleted successfully.",
        "notFound": "Group record not found",
        "duplicateName": "A group with this name already exists.",
        "fileRequired": "The file is required.",
        "imported": "The groups were imported correctly"
      }
    },
    "groupPeople": {
      "menuName": "Group People",
      "pageTitle": "Group People",
      "add": "Add Group People",
      "edit": "Edit Group People",
      "delete": {
        "title": "Delete Group People",
        "text": "Are you sure you want to delete this group people?"
      },
      "groupId": "Group",
      "personId": "Person",
      "validityStart": "Validity Start",
      "validityEnd": "Validity End",
      "messages": {
        "created": "Group Person created successfully.",
        "updated": "Group Person updated successfully.",
        "deleted": "Group Person successfully.",
        "notFound": "Group Person record not found",
        "alreadyExists": "The user already uses this group."
      }
    },
    "groupPermission": {
      "menuName": "Group Permission",
      "pageTitle": "Group Permission",
      "add": "Add Group Permission",
      "edit": "Edit Group Permission",
      "delete": {
        "title": "Delete Group Permission",
        "text": "Are you sure you want to delete this Group Permission?"
      },
      "groupId": "Group",
      "resourceId": "Resource",
      "action": "Action",
      "messages": {
        "created": "Group Permission created successfully.",
        "updated": "Group Permission updated successfully.",
        "deleted": "Group Permission deleted successfully.",
        "notFound": "Group Permission record not found",
        "duplicateName": "A permission with this resource/permission already exists."
      }
    }
  },
  "goals": {
    "menuName": "Goals",
    "kpi": {
      "menuName": "KPI"
    },
    "plan": {
      "menuName": "Plans"
    },
    "target": {
      "menuName": "Targets",
      "kpiOwner": {
        "menuName": "Targets - KPI Owner"
      }
    },
    "actual": {
      "menuName": "Actuals",
      "kpiOwner": {
        "menuName": "Actuals - KPI Owner"
      }
    },
    "discussionNotes": {
      "menuName": "Discussion Notes"
    },
    "flexibleGoal": {
      "menuName": "Flexible Goal"
    },
    "actionPlan": {
      "menuName": "Action Plans"
    },
    "library": {
      "menuName": "Library"
    },
    "category": {
      "menuName": "Category"
    },
    "PlantArea": {
      "menuName": "Plant Area"
    },
    "clerks": {
      "menuName": "KPI Owners"
    },
    "quickEntry": {
      "menuName": "Annual Quick Entry"
    }
  },
  "nineBox": {
    "menuName": "9box",
    "nineBoxForm": {
      "menuName": "Form"
    },
    "nineBoxFormPeople": {
      "menuName": "Form Participants"
    },
    "fillTalentTalk": {
      "menuName": "Fill Talent Talk"
    },
    "nineBoxCalibration": {
      "menuName": "Calibration"
    },
    "fillDevelopmentPlan": {
      "menuName": "Fill Development Plan"
    }
  },
  "pcf": {
    "menuName": "PCF",
    "dashboard": {
      "menuName": "Dashboard"
    },
    "request": {
      "newPCF": {
        "menuName": "New PCF"
      }
    },
    "requestType": {
      "menuName": "Request Type"
    },
    "approvalGroup": {
      "menuName": "Approval Group"
    },
    "requestStatuses": {
      "menuName": "Request Statuses"
    },
    "catalog": {
      "menuName": "Catalog"
    }
  },
  "merit": {
    "menuName": "Merit",
    "meritPlanFormList": {
      "menuName": "Form Participants"
    },
    "meritDashboard": {
      "menuName": "Dashboard"
    },
    "meritPlan": {
      "menuName": "Plan"
    },
    "awardLetter": {
      "menuName": "Award Letter"
    },
    "meritPlanParticipants": {
      "menuName": "Plan Participants"
    }
  },
  "bonus": {
    "menuName": "Bonus",
    "bonusIncentiveGroup": {
      "menuName": "Incentive Group"
    },
    "bonusPlan": {
      "menuName": "Plan"
    },
    "bonusPlanParticipants": {
      "menuName": "Plan Participants"
    },
    "bonusDashboard": {
      "menuName": "Dashboard"
    },
    "awardLetter": {
      "menuName": "Award Letter"
    }
  },
  "cultureTalent": {
    "menuName": "Culture & Talent",
    "culture": {
      "menuName": "Culture and Talent Programs"
    },
    "talent": {
      "menuName": "Training Plataforms"
    }
  },
  "talentMapping": {
    "menuName": "Talent Mapping",
    "skills": {
      "menuName": "Skills"
    },
    "orgChart": {
      "menuName": "Org Chart"
    },
    "myProfile": {
      "menuName": "My profile"
    },
    "degreeTypes": {
      "menuName": "Degree Type",
      "pageTitle": "Degree Type",
      "name": "Name",
      "isActive": "Is Active",
      "add": "Add Degree Type",
      "edit": "Edit Degree Type",
      "delete": {
        "title": "Delete Degree Type",
        "text": "Are you sure you want to delete this Degree Type?"
      },
      "messages": {
        "created": "Degree Type created successfully.",
        "updated": "Degree Type updated successfully.",
        "deleted": "Degree Type deleted successfully.",
        "saveError": "An error occurred while saving the Degree Type. Please try again.",
        "notFound": "Degree Type record not found.",
        "inUse": "Degree Type is in use and cannot be deleted."
      }
    }
  },
  "absenceRequest": {
    "menuName": "Absence Request",
    "createRequest": {
      "menuName": "Create Request"
    },
    "viewManageRequests": {
      "menuName": "My Requests"
    },
    "calendar": {
      "menuName": "Calendar"
    },
    "pendingRequestsAndHistory": {
      "menuName": "Approvals"
    },
    "manageDirectReportsHours": {
      "menuName": "Maintain Balances"
    },
    "upload": {
      "menuName": "Upload"
    },
    "manageAbsenceProfiles": {
      "menuName": "Manage Absence Profiles"
    },
    "manageHolidays": {
      "menuName": "Manage Holidays"
    },
    "hoursCalculationMatrices": {
      "menuName": "Hours Calculation Matrices"
    },
    "manageApprovingDelegate": {
      "menuName": "Delegate Approvals"
    },
    "notification": {
      "menuName": "Absence Notification"
    },
    "manageMatrixCategories": {
      "menuName": "Manage Matrix Categories"
    },
    "manageFloatingHolidayMatrix": {
      "menuName": "Manage Floating Holiday Matrix"
    },
    "manageSickMatrix": {
      "menuName": "Manage Sick Matrix"
    }
  },
  "expenseReport": {
    "menuName": "Expense Reports",
    "createExpenses": {
      "menuName": "Create Request"
    },
    "myExpenses": {
      "menuName": "My Requests"
    },
    "approvals": {
      "menuName": "Expense to Approve"
    },
    "delegateApprovals": {
      "menuName": "Delegate Approvals"
    },
    "preparers": {
      "menuName": "Preparers"
    },
    "categories": {
      "menuName": "Categories"
    },
    "distanceRates": {
      "menuName": "Distance Rates"
    },
    "generalLedgers": {
      "menuName": "General Ledgers"
    },
    "policies": {
      "menuName": "Policies"
    },
    "projects": {
      "menuName": "Projects"
    }
  },
  "salaryExtraPay": {
    "menuName": "Salary 6th/7th Day Pay",
    "createRequest": {
      "menuName": "Create Request"
    },
    "myRequests": {
      "menuName": "My Requests"
    },
    "approvals": {
      "menuName": "Approvals"
    },
    "delegateApprovals": {
      "menuName": "Delegate Approvals"
    },
    "locationSetups": {
      "menuName": "Location Setups"
    },
    "export": {
      "menuName": "Export"
    },
    "policies": {
      "menuName": "Policies"
    },
    "payType": {
      "menuName": "Pay Types"
    },
    "personnelAreaSetups": {
      "menuName": "Personnel Area Setups"
    }
  },
  "developmentPlan": {
    "menuName": "Development Plan",
    "planDelegate": {
      "menuName": "Plan Delegate"
    },
    "questions": {
      "menuName": "Questions"
    },
    "plans": {
      "menuName": "Plans"
    },
    "programs": {
      "menuName": "Programs"
    },
    "notificationSender": {
      "menuName": "Notification Sender"
    },
    "fillDevelopmentPlan": {
      "menuName": "Fill Development Plan"
    },
    "signEvaluations": {
      "menuName": "Sign Evaluations"
    },
    "resultViewer": {
      "menuName": "Result Viewer"
    }
  },
  "survey": {
    "menuName": "Survey",
    "questionCategories": {
      "menuName": "Question Categories"
    },
    "questions": {
      "menuName": "Questions"
    },
    "ratingScales": {
      "menuName": "Rating Scales"
    },
    "actionPlans": {
      "menuName": "Action Plan"
    },
    "people": {
      "menuName": "People"
    },
    "surveys": {
      "menuName": "Survey Forms"
    },
    "notificationSender": {
      "menuName": "Notification Sender"
    },
    "dashboard": {
      "menuName": "Dashboard"
    }
  },
  "hourlyPositions": {
    "menuName": "Hourly Positions",
    "createRequest": {
      "menuName": "Create Request"
    },
    "requests": {
      "menuName": "Requests"
    },
    "employeeSubgroup": {
      "menuName": "Employee Subgroup"
    },
    "hourlyCatalog": {
      "menuName": "Hourly Catalog"
    }
  },
  "vuestic": {
    "search": "Search",
    "noOptions": "Items not found",
    "ok": "OK",
    "cancel": "Cancel",
    "uploadFile": "Select file",
    "undo": "Undo",
    "dropzone": "Drop files here to upload",
    "fileDeleted": "File deleted",
    "closeAlert": "close alert",
    "backToTop": "back to top",
    "toggleDropdown": "toggle dropdown",
    "carousel": "carousel",
    "goPreviousSlide": "go to previous slide",
    "goNextSlide": "go to next slide",
    "goSlide": "go to slide {index}",
    "slideOf": "slide {index} of {length}",
    "close": "close",
    "openColorPicker": "open color picker",
    "colorSelection": "color selection",
    "colorName": "color {color}",
    "decreaseCounter": "decrease counter",
    "increaseCounter": "increase counter",
    "selectAllRows": "select all rows",
    "sortColumnBy": "sort column by {name}",
    "selectRowByIndex": "select row {index}",
    "resetDate": "reset date",
    "nextPeriod": "next period",
    "switchView": "switch view",
    "previousPeriod": "previous period",
    "removeFile": "remove file",
    "reset": "reset",
    "pagination": "pagination",
    "goToTheFirstPage": "go to the first page",
    "goToPreviousPage": "go to the previous page",
    "goToSpecificPage": "go to page {page}",
    "goToSpecificPageInput": "enter page number",
    "goNextPage": "go to the next page",
    "goLastPage": "go to the last page",
    "currentRating": "current rating {value} of {max}",
    "voteRating": "vote rating {value} of {max}",
    "optionsFilter": "options filter",
    "splitPanels": "split panels",
    "movePaginationLeft": "move pagination left",
    "movePaginationRight": "move pagination right",
    "resetTime": "reset time",
    "closeToast": "close notification",
    "selectedOption": "Selected option",
    "noSelectedOption": "No option selected",
    "breadcrumbs": "breadcrumbs",
    "counterValue": "counter value",
    "selectedDate": "selected date",
    "selectedTime": "selected time",
    "progressState": "progress state",
    "color": "color",
    "next": "Next",
    "back": "Back",
    "finish": "Finish",
    "step": "step",
    "progress": "progress",
    "loading": "Loading",
    "sliderValue": "The current slider value is {value}",
    "switch": "Switch",
    "inputField": "Input field",
    "fileTypeIncorrect": "Incorrect file type",
    "select": "Select an option"
  },
  "orgChart": {
    "title": "Organization Chart",
    "menuTitle": "Org Chart",
    "menuName": "Org Chart",
    "organization": "Organization",
    "directReports": "Direct Reports",
    "showEmployeeDetails": "Show employee details",
    "goUp": "Go up one level",
    "navigateHere": "Navigate here",
    "vacant": "Vacant",
    "position": "Position",
    "plant": "Plant",
    "businessArea": "Business Area",
    "personnelArea": "Personnel Area",
    "costCenter": "Cost Center",
    "hireDate": "Hire Date",
    "score360": "360 Score",
    "scoreGoals": "Goals Score",
    "score9box": "9-Box",
    "person": "Person",
    "employeeType": "Employee Type",
    "view": "View",
    "viewOptions": {
      "basic": "Basic",
      "performance": "Performance",
      "headcount": "Headcount"
    },
    "headcount": {
      "directTotal": "Direct Total",
      "directSESNE": "Direct SE/SNE",
      "total": "Headcount Total",
      "spanOfControl": "Span of Control",
      "se": "Salary Employees",
      "sne": "SNE Employees",
      "hourly": "Hourly Employees",
      "truck": "Truck Employees",
      "work": "Work Employees"
    },
    "hidePeers": "Hide peers",
    "showPeers": "Show peer(s)",
    "collapse": "Collapse",
    "expand": "Expand",
    "errors": {
      "salariedTypeCannotBeRemoved": "Salaried type cannot be removed.",
      "employeeNotInTree": "This employee is out of the Organization Chart's tree and can't be displayed."
    }
  }
}
